"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformSchematicLayerSet = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformSchematicLayerSet extends TransformObject_1.TransformObject {
    constructor(parent, baseLayerSet) {
        super(parent, {
            baseLayerSet,
        }, baseLayerSet.id, new Set());
        this.deduplicationKey = baseLayerSet.id;
    }
    get layerSetId() {
        return this._sharedData.baseLayerSet.id;
    }
    compile() {
        return this._sharedData.baseLayerSet;
    }
}
exports.TransformSchematicLayerSet = TransformSchematicLayerSet;
//# sourceMappingURL=TransformSchematicLayerSet.js.map